// Buckets a product into one of three categories used by promo codes:
// 'ebook', 'audiobook', or 'physical'. Keep this file in sync with
// functions/lib/productCategory.js: the Cloud Function cannot import from
// src/, so the two implementations must match.

const EBOOK_KEYWORDS = ['ebook', 'epub', 'kindle', 'digital'];
const AUDIOBOOK_KEYWORDS = ['audiobook', 'audio', 'mp3', 'm4b'];
const PHYSICAL_KEYWORDS = [
  'paperback', 'hardback', 'hardcover', 'print', 'signed', 'physical', 'box',
];

function gatherHaystack(product) {
  if (!product) return '';
  return [
    product.productType,
    product.type,
    product.category,
    product.name,
    product.title,
    product.productName,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

// Returns 'ebook' | 'audiobook' | 'physical'. Order matters: digital formats
// are checked before physical so an "audiobook signed certificate" stays an
// audiobook. Unrecognised products default to 'physical' to match the
// pre-existing server fallback at functions/index.js (validatePromoCode).
export function bucketProductType(product) {
  const haystack = gatherHaystack(product);
  if (!haystack) return 'physical';
  if (EBOOK_KEYWORDS.some((k) => haystack.includes(k))) return 'ebook';
  if (AUDIOBOOK_KEYWORDS.some((k) => haystack.includes(k))) return 'audiobook';
  if (PHYSICAL_KEYWORDS.some((k) => haystack.includes(k))) return 'physical';
  return 'physical';
}

export function isPhysicalProduct(product) {
  return bucketProductType(product) === 'physical';
}
